module.exports = __webpack_public_path__ + "img/web_success_step_01.378392c1.png";